<template>
  <div class="warp">
    <div class="content">
      <div class="right">
        <div class="logo">
          <div class="titles">
            <h1>欢迎登录</h1>
            <!-- <span>中央厨房后台管理系统</span> -->
            <span>智慧后厨管理系统</span>
          </div>
        </div>

        <el-form ref="loginForm" :rules="rules" :model="loginForm" class="login-form">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" type="text" placeholder="请输入账号" name="username">
              <svg-icon slot="prefix" icon-class="user" class="el-icon-user-solid" />
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input ref="passwordInput" v-model="loginForm.password" type="password" placeholder="请输入密码"
              :show-password="showPassword" name="password" @focus="isPwdFocus = true" @blur="isPwdFocus = false"
              @keyup.enter.native="handleLogin">
              <svg-icon slot="prefix" icon-class="lock" class="el-icon-lock" />
            </el-input>
            <i :class="showPassword ? 'el-icon-eye' : 'el-icon-eye-close'" @click="togglePasswordVisibility"
              v-show="loginForm.password || isPwdFocus"></i>
            <!-- 新增：记住密码复选框 -->
            <el-checkbox v-model="isRememberPwd" label="记住密码" class="remember-pwd-checkbox">
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button class="login-btn" @click="handleLogin">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="el-login-footer">
      <!-- <span> @中研制业技术支持</span> -->

      <span> @安徽环宝厨房设备制作有限公司</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { getLogin } from "@/api/login";
export default {

  data() {
    return {
      types1: '',
      loginForm: {
        username: "",
        password: "",
      },
      publicKey: null,
      showPassword: false, // 初始值改为 false，更符合常规
      isRememberPwd: false, // 新增：记住密码的勾选状态
      isPwdFocus: false,    // 新增：密码框是否聚焦，用于修正小眼睛图标显示
      // 表单校验
      rules: {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
      }
    };
  },
  // 新增：组件创建时，从 localStorage 读取用户信息
  created() {
    this.loadUserInfo();
  },
  methods: {
    // 新增：从 localStorage 加载用户信息
    loadUserInfo() {
      const savedUser = localStorage.getItem('savedUser');
      if (savedUser) {
        try {
          const userInfo = JSON.parse(savedUser);
          this.loginForm.username = userInfo.username;
          this.loginForm.password = userInfo.password;
          this.isRememberPwd = true;
          // 密码框自动填充后，强制更新视图以修正小眼睛图标
          this.$nextTick(() => {
            if (this.$refs.passwordInput) {
              this.$refs.passwordInput.$el.querySelector('input').addEventListener('input', () => {
                this.isPwdFocus = true;
              });
            }
          });
        } catch (e) {
          console.error('解析保存的用户信息失败:', e);
          localStorage.removeItem('savedUser'); // 解析失败则清除
        }
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          getLogin({
            account: this.loginForm.username,
            password: this.loginForm.password,
          }).then(response => {
            console.log(response);
            const userId = response.data.userId;
            this.$message({
              message: response.message,
              type: 'success'
            });

            if (response.code === 200) {
              // 新增：根据是否勾选记住密码，来决定是否保存到 localStorage
              if (this.isRememberPwd) {
                const userInfo = {
                  username: this.loginForm.username,
                  password: this.loginForm.password
                };
                localStorage.setItem('savedUser', JSON.stringify(userInfo));
              } else {
                // 如果未勾选，则清除 localStorage 中的用户信息
                localStorage.removeItem('savedUser');
              }

              this.$store.dispatch('login', userId);
              localStorage.setItem('userId', userId);
              localStorage.setItem('roleId', response.data.roleId);


              if (response.data.roleId == 4) {
                this.$router.push("/quotation").then(() => {
                  if (!Vue.prototype.$bus) {
                    Vue.prototype.$bus = new Vue();
                  }
                  Vue.prototype.$bus.$emit('loadMenu');
                });
              } else {
                this.$router.push("/index").then(() => {
                  if (!Vue.prototype.$bus) {
                    Vue.prototype.$bus = new Vue();
                  }
                  Vue.prototype.$bus.$emit('loadMenu');
                });
              }
            }
          }).catch((error) => {
            console.error('请求出错:', error.response);
            let errorMsg = '登录失败，请稍后重试';
            if (error.response) {
              if (error.response.status === 500) {
                errorMsg = '用户名或密码错误，请重新输入';
              } else if (error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
              }
            }
            this.$message({
              message: errorMsg,
              type: 'error'
            });
          });
        } else {
          this.$message({
            message: '请输入用户名和密码',
            type: 'warning'
          });
          return false;
        }
      });
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style lang="scss" scoped>
// ... (你已有的样式保持不变) ...
.warp {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url('../assets/logo2.png') no-repeat;
  background-size: cover;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 998;
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
}

.content {
  width: 420px;
  height: 500px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  margin-right: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 30px;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.titles {
  display: flex;
  flex-direction: column;
}

.titles h1 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
}

.titles span {
  font-size: 16px;
  color: #666;
}

.login-form {
  width: 100%;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 24px;
}

.el-input {
  border-radius: 20px;
}

.el-input__inner {
  background-color: rgba(245, 245, 245, 0.8);
  border: 1px solid rgba(200, 200, 200, 0.5);
  height: 44px;
}

.login-btn {
  width: 100%;
  font-size: 18px;
  border-radius: 20px;
  color: #fff;
  background: linear-gradient(to right, #FA9B64, #EA5906);
  border: none;
  height: 44px;
  margin-top: 15px;
}

.login-btn:hover {
  opacity: 0.9;
}

.el-icon-eye,
.el-icon-eye-close {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  z-index: 10;
}

// 新增：记住密码复选框的样式
.remember-pwd-checkbox {
  position: absolute;
  bottom: -40px; // 调整位置，使其在输入框下方
  left: 0;
  font-size: 14px;
  color: #666;

}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 30px;
  width: 100%;
  left: 85%;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.login-code-img {
  height: 38px;
}
</style>
